import { render, staticRenderFns } from "./LoadingAnimation.vue?vue&type=template&id=38ff7e64"
import script from "./LoadingAnimation.vue?vue&type=script&lang=js"
export * from "./LoadingAnimation.vue?vue&type=script&lang=js"
import style0 from "./LoadingAnimation.vue?vue&type=style&index=0&id=38ff7e64&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports